/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Event_Group_LabelInputs */

const en_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group`)
};

const fr_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements`)
};

const de_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppe`)
};

const it_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi`)
};

const ru_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий`)
};

const es_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos`)
};

const zh_cn2_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组`)
};

const ja_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ`)
};

const hi_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप`)
};

const pt_pt2_video_export_event_group_label = /** @type {(inputs: Video_Export_Event_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos`)
};

/**
* | output |
* | --- |
* | "Event Group" |
*
* @param {Video_Export_Event_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_event_group_label = /** @type {((inputs?: Video_Export_Event_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Event_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_event_group_label(inputs)
	if (locale === "de") return de_video_export_event_group_label(inputs)
	if (locale === "it") return it_video_export_event_group_label(inputs)
	if (locale === "ru") return ru_video_export_event_group_label(inputs)
	if (locale === "es") return es_video_export_event_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_event_group_label(inputs)
	if (locale === "ja") return ja_video_export_event_group_label(inputs)
	if (locale === "hi") return hi_video_export_event_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_event_group_label(inputs)
	return en_video_export_event_group_label(inputs)
});